import './EntitlementsUseCaseSelection.scss';

import { InputRadioButton } from '@whistler-ui/k2/components/InputRadioButton';
import { Form, withFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { ENTITLEMENT_SERVER_SELECTION_OPTIONS } from '../../constants';
import { commonPageStylesIdentifier } from '../../constants';

const EntitlementsUseCaseSelectionForm = props => {
  const componentName = 'c-EntitlementsUseCaseSelection';
  const { t } = useTranslation();
  const { onChange, setFieldValue } = props;

  useEffect(() => {
    setFieldValue('entitlementServer', true);
    onChange(ENTITLEMENT_SERVER_SELECTION_OPTIONS.ENTITLEMENT_SERVER);
  }, []);

  return (
    <div className={componentName}>
      <div className={`${componentName}__title-row`}>
        {t('componentEntitlementsUseCaseSelection_title')}
      </div>

      <Form autoComplete={'off'}>
        <div className={`${componentName}__row`}>
          <div className={`${componentName}__section`}>
            <InputRadioButton
              variant="value-label"
              groupName={'entitlementServerGroup'}
              type="text"
              name="noEntitlementServer"
              values={[
                {
                  value:
                    ENTITLEMENT_SERVER_SELECTION_OPTIONS.ENTITLEMENT_SERVER,
                },
              ]}
              checked
              error={false}
              errorMessage={t(
                'componentEntitlementsUseCaseSelection_field_required',
              )}
            />
            <div
              htmlFor=""
              className={`${commonPageStylesIdentifier}__field-label`}
            >
              <div className={`${componentName}__large-label`}>
                {t('componentEntitlementsUseCaseSelection_dont_use_server_1')}
              </div>
              <div className={`${componentName}__small-label`}>
                {t('componentEntitlementsUseCaseSelection_dont_use_server_2')}
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

const EntitlementsUseCaseSelection = withFormik({
  mapPropsToValues() {
    return {
      entitlementServer: true,
    };
  },
  handleSubmit(values, { setSubmitting }) {
    setSubmitting(false);
  },
  validationSchema: yup.object().shape({
    entitlementServer: yup
      .boolean()
      .test(value => value === true || value === false)
      .required(
        'componentEntitlementsUseCaseSelection_server_selection_required',
      ),
  }),
  displayName: 'EntitlementsUseCaseSelectionForm',
})(EntitlementsUseCaseSelectionForm);

EntitlementsUseCaseSelectionForm.propTypes = {
  setFieldValue: PropTypes.func,
  isButtonEnabled: PropTypes.func,
};
export default EntitlementsUseCaseSelection;
